import { render } from "./personnel.vue?vue&type=template&id=310c3e59&scoped=true"
import script from "./personnel.vue?vue&type=script&lang=js"
export * from "./personnel.vue?vue&type=script&lang=js"

import "./personnel.vue?vue&type=style&index=0&id=310c3e59&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310c3e59"]])

export default __exports__